var map = {
	"./exam-mode.svg": [
		95426,
		5426
	],
	"./flight--roster.svg": [
		47074,
		7074
	],
	"./home.svg": [
		74174,
		4174
	],
	"./information.svg": [
		73787,
		3787
	],
	"./play--outline.svg": [
		80019,
		19
	],
	"./settings.svg": [
		20716,
		716
	],
	"./task--tools.svg": [
		73867,
		3867
	],
	"./template.svg": [
		79477,
		9477
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 44913;
module.exports = webpackAsyncContext;